import { Link } from "react-router-dom";

import AppLogo from "@/assets/img/logo_text_horizontal.png";
import EstimeoLogo from "@/assets/img/estimeo_logo_horizontal.png";

const Values = ({ values, onChange }) => {
  const isDataValid = () => values.valuation_game_ca && values.valuation_game_ebe;

  return (
    <div className="flex flex-col px-8 py-8 w-[42rem] h-full justify-center bg-white">
      <div className="flex items-center mb-2">
        <div className="w-24 mb-4">
          <img className="w-full drop-shadow-md" src={AppLogo} alt="logo" />
        </div>
        <div className="text-5xl text-gray-700 font-medium mb-3 ml-1 mr-2">&times;</div>
        <div className="w-32 mb-4">
          <img className="w-full drop-shadow-md" src={EstimeoLogo} alt="logo" />
        </div>
      </div>
      <div className="flex flex-col items-start space-y-8">
        <h1 className="text-xl text-primary font-semibold">Informations financières</h1>
        <div className="space-y-4 w-full">
          <div className="space-y-2">
            <p className="text-gray-600 font-medium">Quel est votre CA lors du dernier exercice ?</p>
            <input
              type="number"
              name="valuation_game_ca"
              placeholder="Saisissez le CA"
              value={values.valuation_game_ca ? values.valuation_game_ca.toString() : ""}
              onChange={(e) => onChange({ ...values, valuation_game_ca: Number(e.target.value) })}
              className="input shadow"
            />
          </div>

          <div className="space-y-2">
            <p className="text-gray-600 font-medium">Quel est votre EBE lors du dernier exercice ?</p>
            <input
              type="number"
              name="valuation_game_ebe"
              placeholder="Saisissez l'EBE"
              value={values.valuation_game_ebe ? values.valuation_game_ebe.toString() : ""}
              onChange={(e) => onChange({ ...values, valuation_game_ebe: Number(e.target.value) })}
              className="input shadow"
            />
          </div>
        </div>

        <div className="flex gap-4">
          <Link to="/valuation-game/sme/company" className="primary-button px-8">
            Précédent
          </Link>

          {isDataValid() ? (
            <Link to="/valuation-game/sme/personal-info" className="primary-button px-8">
              Suivant
            </Link>
          ) : (
            <button disabled className="primary-button px-8">
              Suivant
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Values;
